<template>
	<v-navigation-drawer permanent v-model="drawer" class="right-menu" :width="400">
		<v-toolbar flat>
			<v-list>
				<v-list-tile>
					<v-list-tile-title class="title">
						Asko Pro
					</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-toolbar>

		<v-divider></v-divider>

		<v-list dense>
			<div v-for="item in items()" :key="item.title">
				<v-list-group v-model="item.active" no-action v-if="item.items">
					<template v-slot:activator>
						<v-list-tile :class="{ 'selected-group': selectedListGroup(item) }">
							<v-list-tile-action>
								<v-icon>{{ item.icon }}</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title> {{ item.title }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</template>

					<v-list-tile
						v-for="subItem in item.items"
						:key="subItem.title"
						v-model="subItem.active"
						@click="subItem.clicked"
						:class="{ 'selected-group': selectedSubListGroup(subItem, item) }"
					>
						<v-list-tile-content>
							<v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list-group>

				<v-list-tile
					@click="item.clicked"
					v-model="item.active"
					v-if="!item.items"
					:class="{ 'selected-group': selectedListGroup(item) }"
				>
					<v-list-tile-action>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-tile-action>

					<v-list-tile-content>
						<v-list-tile-title> {{ item.title }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</div>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import { AUTH_LOGOUT, ERROR, SET_BOT, SET_SUBBOT } from '../variables'

export default {
	data() {
		return {
			drawer: true,
			selected: null,
			selectedGroup: null,
			currentIndex: 0,
			currentSubIndex: 0,
		}
	},
	watch: {
		$route: async function(el) {
			this.setActiveItem(el.meta)
		},
	},
	computed: {
		bots() {
			return this.$store.getters.bots
		},
	},
	methods: {
		botItems() {
			return this.bots.reduce((acc, bot) => {
				acc.push({
					title: bot.name,
					key: bot.name,
					id: bot._id,
					icon: 'account_circle',
					items: [
						{
							active: false,
							key: 'dashboard',
							title: "Vue d'ensemble",
							clicked: () => {
								this.$router.push({ name: 'Dashboard', params: { botId: bot._id } })
							},
						},
						{
							active: false,
							key: 'users',
							title: 'Utilisateurs',
							clicked: () => {
								this.$router.push({ name: 'UsersList', params: { botId: bot._id } })
							},
						},
						{
							active: false,
							key: 'userGroups',
							title: 'Cliniques',
							clicked: () => {
								this.$router.push({ name: 'UserGroupList', params: { botId: bot._id } })
							},
						},
						{
							active: false,
							title: "Liste d'envoi",
							key: 'userLists',
							clicked: () => {
								this.$router.push({ name: 'UserListList', params: { botId: bot._id } })
							},
						},
						{
							active: false,
							title: 'Groupes',
							key: 'subBots',
							clicked: () => {
								this.$router.push({ name: 'SubBotList', params: { botId: bot._id } })
							},
						},
						{
							active: false,
							title: 'Variables',
							key: 'variables',
							clicked: () => {
								this.$router.push({ name: 'BotVariableList', params: { botId: bot._id } })
							},
						},
						{
							active: false,
							title: 'Configuration',
							key: 'parameter',
							clicked: () => {
								this.$router.push({ name: 'BotDetail', params: { botId: bot._id } })
							},
						},
					],
				})
				return acc
			}, [])
		},
		items() {
			return [
				{
					title: 'Utilisateurs pro',
					key: 'proUser',
					icon: 'account_circle',
					items: [
						{
							active: false,
							title: 'liste',
							key: 'list',
							clicked: () => {
								this.$router.push({ name: 'ProUserList' })
							},
						},
						{
							active: false,
							title: 'Ajouter',
							key: 'add',
							clicked: () => {
								this.$router.push({ name: 'AddProUser' })
							},
						},
					],
				},
				{
					title: 'Utilisateurs',
					key: 'botUser',
					icon: 'account_circle',
					clicked: () => {
						this.$router.push({ name: 'botUserList' })
					},
				},
				{
					title: 'Groupe de bots',
					key: 'botGroups',
					icon: 'group',
					items: [
						{
							active: false,
							title: 'liste',
							key: 'list',
							clicked: () => {
								this.$router.push({ name: 'BotGroupsList' })
							},
						},
						{
							active: false,
							title: 'Ajouter',
							key: 'add',
							clicked: () => {
								this.$router.push({ name: 'AddBotGroups' })
							},
						},
					],
				},
				{
					title: 'Paramètrage par défaut',
					key: 'defaultParameter',
					icon: 'settings',
					items: [
						{
							active: false,
							title: 'liste',
							key: 'list',
							clicked: () => {
								this.$router.push({ name: 'DefaultParametersList' })
							},
						},
						{
							active: false,
							title: 'Ajouter',
							key: 'add',
							clicked: () => {
								this.$router.push({ name: 'AddDefaultParameters' })
							},
						},
					],
				},
				...this.botItems(),
				{
					title: 'Ajouter un bot',
					key: 'addBot',
					icon: 'add',
					clicked: () => {
						this.$router.push({ name: 'AddBot' })
					},
				},
				{
					title: 'Deconnexion',
					key: 'logout',
					icon: 'exit_to_app',
					clicked: () => {
						this.$store
							.dispatch(AUTH_LOGOUT)
							.then(() => {
								this.$router.push({ name: 'Login' })
							})
							.catch((err) => {
								console.error('failed', err)
							})
					},
				},
			]
		},
		setActiveItem(routeMeta) {
			let items = this.items()
			this.currentIndex = items.findIndex((el) => el.key === routeMeta.navigationTitle)

			// bot case
			if (this.currentIndex === -1) {
				this.currentIndex = items.findIndex((el) => {
					return el.id === this.$route.params.botId
				})
			}

			if (this.currentIndex >= 0 && items[this.currentIndex].items) {
				this.currentSubIndex = items[this.currentIndex].items.findIndex((el) => el.key === routeMeta.navigationSubTitle)
			}
		},
		selectedListGroup(item) {
			if (this.currentIndex >= 0) {
				return this.items()[this.currentIndex].key === item.key
			}
			return false
		},
		selectedSubListGroup(subItem, item) {
			let items = this.items()
			if (
				this.currentIndex >= 0 &&
				this.currentIndex < items.length &&
				items[this.currentIndex].items &&
				this.currentSubIndex >= 0 &&
				this.currentSubIndex < items[this.currentIndex].items.length
			) {
				return (
					items[this.currentIndex].items[this.currentSubIndex].key === subItem.key &&
					item.key === items[this.currentIndex].key
				)
			}
			return false
		},
	},
	mounted() {
		this.setActiveItem(this.$route.meta)
	},
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';

.v-navigation-drawer {
	height: 100vh;
	.selected-group {
		color: $primary-color;
		.theme--light.v-icon {
			color: $primary-color;
		}
	}
}

.right-menu {
	.step {
		justify-content: center;
		margin: 5px 0;
		cursor: pointer;
		&:hover {
			background-color: #eeeeee;
		}
		.step-text {
			width: 80%;
			margin-top: 10px;
			margin-bottom: 20px;
			align-self: center;
		}
		.step-number {
			background-color: black;
			color: $primary-color;
			border-radius: 50%;
			text-align: center;
			width: 20px;
			height: 20px;
		}
	}
}

a {
	text-decoration: none;
	color: black;
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/navigation.vue